import axios from 'axios';

const Env = {
  install: function (Vue) {
    Vue.prototype.$Env = {
      ...process.env,
      init(fetchEnvUrl) {
        return axios.get(fetchEnvUrl)
          .then((response) => {
            Object.assign(this, response.data.env);
          })
          .catch(err => {
            console.error("Could not initialise environment variables from", fetchEnvUrl, err); // eslint-disable-line no-console
          });
      },
      get(param, defaultValue) {
        return (this[param] != null) ? this[param] : defaultValue;
      }
    }
  }
}

export default Env;
